import React from 'react'
import PropTypes from 'prop-types'

import { compose, withTranslation, getContext } from '@hocs'
import { imageUrl } from '@libs/appUrl'

import PopSlidein from '@components/PopSlidein'
import SlideinItem from '@components/PopSlidein/SlideinItem'

import styles from './SharePop.scss'

const ReplyPop = ({
  replyPost: post,
  isOpen,
  onClose,
  replyID = -1,
  isCurrentUserComment = false,
  deleteReply,
  onClickReport,
  openConfirmDialog,
  t,
}) => {
  const getPostId = (post) => post.get('postID')
  const deleteComment = ({ post, replyID = -1, deleteReply }) => () =>
    openConfirmDialog({
      title: t('common:你確定要刪除此則回覆嗎？'),
      onSure: () => replyID !== -1 && deleteReply({ postID: getPostId(post), replyID }),
    })
  const reportComment = ({ post, replyID = -1 }) => () =>
    openConfirmDialog({
      title: t('common:是否檢舉此回覆?'),
      onSure: () => onClickReport({ postID: getPostId(post), replyID }),
    })
  return (
    <PopSlidein isOpen={isOpen} close={onClose}>
      <style jsx>{styles}</style>
      <div className="popSlidein__wrapper popSlidein__wrapper--info">
        <div className="popSlidein__content popSlidein__content--info">
          <div className="popSlidein__actionIcons">
            {isCurrentUserComment && (
              <SlideinItem
                img={imageUrl('/img/globalicon/share-delete@3x.png')}
                onClick={deleteComment({ post, replyID, deleteReply })}
                text={t('common:刪除')}
              />
            )}
            <SlideinItem
              img={imageUrl('/img/globalicon/share-alert@3x.png')}
              onClick={reportComment({ post, replyID })}
              text={t('common:檢舉')}
            />
          </div>
        </div>
        <div className="btn-cancel" onClick={onClose} data-btn-text={t('common:關閉')} />
      </div>
    </PopSlidein>
  )
}

export default compose(
  withTranslation(),
  getContext({
    deleteReply: PropTypes.func.isRequired,
  }),
)(ReplyPop)
